import { render, staticRenderFns } from "./dashboard-initialiser.vue?vue&type=template&id=501dc3d2&scoped=true"
import script from "./dashboard-initialiser.vue?vue&type=script&lang=js"
export * from "./dashboard-initialiser.vue?vue&type=script&lang=js"
import style0 from "./dashboard-initialiser.vue?vue&type=style&index=0&id=501dc3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501dc3d2",
  null
  
)

export default component.exports